import domain from "./domain";
import { resetWorkspace } from "./events";
import { WorkspaceResource } from "dy-frontend-http-repository/lib/modules/Workspace/resources";

// Workspace resource
export const $workspace = domain
    .createStore<WorkspaceResource | null>(null)
    .reset(resetWorkspace);
